import { environment } from "@orderna/admin-panel/src/environments/environment";

export const REGISTER_ANALYTICS_API_URL = `${environment.api}/analytics/register-sessions`;
